export default (win: Window, key: string) =>
  new URLSearchParams(win?.location?.search).get(key) || '';
